import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=466bd0bc&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"
import style0 from "./Form2.vue?vue&type=style&index=0&id=466bd0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bd0bc",
  null
  
)

export default component.exports